import { CSSProperties } from "react";
import { styles } from "./styles";
import dotTMSVG from "./assets/Dot_TM.svg";

interface Props {
  className?: string;
  style?: CSSProperties;
}

export const BlueDot = ({ className, style }: Props) => (
  <img
    src={dotTMSVG}
    alt="dot"
    className={className}
    style={{
      ...styles.blueDot,
      ...style,
    }}
  />
);
